var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { AwsUi } from '../../../core/runtime/src';
import { Icon } from '../../icon/src';
import { Checkbox } from '../../checkbox/src';
var splitOnFiltering = function (str, highlightText) {
    // Filtering needs to be case insensitive
    var filteringPattern = highlightText.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&');
    var regexp = new RegExp(filteringPattern, 'gi');
    var noMatches = str.split(regexp);
    var matches = str.match(regexp);
    return { noMatches: noMatches, matches: matches };
};
// Returns Mithril virtual element, we can't import the types yet
var Highlight = function (_a) {
    var str = _a.str;
    return str && AwsUi.__createElement("span", { className: prefixClass('filtering-match-highlight') }, str);
};
// Returns an array of Mithril virtual element, we can't import the types yet
var HighlightMatch = function (_a) {
    var str = _a.str, highlightText = _a.highlightText;
    if (!str || !highlightText) {
        return [str];
    }
    if (str === highlightText) {
        return AwsUi.__createElement(Highlight, { str: str });
    }
    var _b = splitOnFiltering(str, highlightText), noMatches = _b.noMatches, matches = _b.matches;
    var highlighted = [];
    noMatches.forEach(function (noMatch, idx) {
        highlighted.push(noMatch);
        if (matches && idx < matches.length) {
            highlighted.push(AwsUi.__createElement(Highlight, { str: matches[idx] }));
        }
    });
    return highlighted;
};
var prefixClass = function (className, excludeClasses) {
    if (excludeClasses === void 0) { excludeClasses = false; }
    return !excludeClasses && "awsui-select-option-" + className;
};
var Label = function (_a) {
    var label = _a.label, prefix = _a.prefix, highlightText = _a.highlightText;
    return (AwsUi.__createElement("span", { className: prefixClass('label') },
        prefix && AwsUi.__createElement("span", { className: prefixClass('label-prefix') },
            prefix,
            " "),
        AwsUi.__createElement(HighlightMatch, { str: label, highlightText: highlightText })));
};
var LabelTag = function (_a) {
    var labelTag = _a.labelTag, highlightText = _a.highlightText;
    return labelTag && (AwsUi.__createElement("span", { className: prefixClass('label-tag') },
        AwsUi.__createElement(HighlightMatch, { str: labelTag, highlightText: highlightText })));
};
var Description = function (_a) {
    var description = _a.description, highlightText = _a.highlightText;
    return description && (AwsUi.__createElement("div", { className: prefixClass('description') },
        AwsUi.__createElement(HighlightMatch, { str: description, highlightText: highlightText })));
};
var Tags = function (_a) {
    var tags = _a.tags, highlightText = _a.highlightText;
    return tags && (AwsUi.__createElement("div", { className: prefixClass('tags') }, tags.map(function (tag) { return (AwsUi.__createElement("span", { className: prefixClass('tag') },
        AwsUi.__createElement(HighlightMatch, { str: tag, highlightText: highlightText }))); })));
};
var FilteringTags = function (_a) {
    var filteringTags = _a.filteringTags, highlightText = _a.highlightText;
    if (!highlightText || !filteringTags) {
        return;
    }
    var searchElement = highlightText.toLowerCase();
    return (AwsUi.__createElement("div", { className: prefixClass('tags') }, filteringTags.map(function (filteringTag) {
        var match = filteringTag.toLowerCase().indexOf(searchElement) !== -1;
        if (match) {
            return (AwsUi.__createElement("span", { className: prefixClass('tag') },
                AwsUi.__createElement(HighlightMatch, { str: filteringTag, highlightText: highlightText })));
        }
    })));
};
var OptionIcon = function (_a) {
    var iconName = _a.iconName, iconUrl = _a.iconUrl, iconAlt = _a.iconAlt, iconSize = _a.iconSize;
    if (!iconName && !iconUrl) {
        return;
    }
    return (AwsUi.__createElement("span", { className: prefixClass('icon') },
        AwsUi.__createElement(Icon, { name: iconName, url: iconUrl, alt: iconAlt, size: iconSize })));
};
export var Option = function (_a) {
    var option = _a.option, disabled = _a.disabled, selected = _a.selected, highlightText = _a.highlightText, selectable = _a.selectable, excludeClasses = _a.excludeClasses, onSelected = _a.onSelected, hasCheckbox = _a.hasCheckbox;
    if (!option) {
        return;
    }
    var classes = ['awsui-select-option'];
    selectable && classes.push(prefixClass('selectable'));
    disabled && classes.push(prefixClass('disabled'));
    var attributes = {
        title: option.label || option.value,
        'data-value': option.id || option.value,
        className: !excludeClasses && classes.join(' ')
    };
    if (selectable && onSelected) {
        attributes.onmouseup = function (event) {
            var isCheckbox = event && event.target.type === 'checkbox';
            // Checkbox is uncontrollable component. When clicking on it directly, its change event happens after this mouseup event which reverts the
            // checked state. To prevent the reverting issue, we skip calling the onSelected here and let the onChange event of the checkbox handles it
            if (!isCheckbox) {
                onSelected(option);
            }
        };
    }
    var onCheckboxChange = function () { return onSelected(option); };
    return (AwsUi.__createElement("div", __assign({}, attributes),
        hasCheckbox && (AwsUi.__createElement(Checkbox, { className: prefixClass('checkbox'), checked: !!selected, disabled: !!disabled, change: onCheckboxChange })),
        AwsUi.__createElement(OptionIcon, { iconName: option.iconName, iconUrl: option.iconUrl, iconAlt: option.iconAlt, iconSize: option.description || option.tags ? 'big' : 'normal' }),
        AwsUi.__createElement("div", { className: prefixClass('content') },
            AwsUi.__createElement("div", { className: prefixClass('label-content') },
                AwsUi.__createElement(Label, { label: option.label || option.value, prefix: option.__labelPrefix, highlightText: highlightText }),
                AwsUi.__createElement(LabelTag, { labelTag: option.labelTag, highlightText: highlightText })),
            AwsUi.__createElement(Description, { description: option.description, highlightText: highlightText }),
            AwsUi.__createElement(Tags, { tags: option.tags, highlightText: highlightText }),
            AwsUi.__createElement(FilteringTags, { filteringTags: option.filteringTags, highlightText: highlightText }))));
};
//# sourceMappingURL=option.js.map